export const THREADS = "Threads";
export const HOOPS = "Hoops";
export const MACHINES = "Machines";